// services/litshield/litshieldApi.ts

import baseApi from "../../lib/baseApi";     

interface AccessResponse {
  access_granted: boolean;
  expires_at: string | null;
  pin_security_enabled: boolean;
}

// Check if the user has access to a specific scope ---------------------------------------------------
export const checkLITShieldAccessApi = async (scope: string): Promise<AccessResponse> => {
  const response = await baseApi.get(`/security/check?scope=${scope}`);
  return response.data;
}; 

// Enter scope with PIN for security access ----------------------------------------------------------
export const enterLITShieldAccessApi = async (scope: string, pin: string): Promise<AccessResponse> => {
  const response = await baseApi.post(`/security/enter/`, {
    scope,
    pin,
  });
  return response.data;
};

// Logout multiple scopes at once --------------------------------------------------------------------
export const logoutMultipleLITShieldScopesApi = async (scopes: string[]): Promise<void> => {
  await baseApi.post("/security/logout/", { scopes });
};
